/**
 * Restore Add to cart on Searchanise cards for partial-reel products.
 * Searchanise Custom JS marks products sold out when reel_units > quantity_total,
 * but the PDP allows purchasing remaining inventory.
 */
const restorePartialReelAddToCart = () => {
  const $ = window.Searchanise?.$;

  if (!$) {
    return;
  }

  const addToCartLabel =
    window.Searchanise?.GetWidgets?.()?.options?.LabelResultsAddToCart || 'Add to cart';

  $(document).on('Searchanise.ResultsUpdated', (_event, container) => {
    setTimeout(() => {
      $('.snize-product', container).each(function () {
        const productData = $(this).data('snize_item_data');
        const quantityTotal = parseInt(productData?.quantity_total, 10);

        if (!productData || Number.isNaN(quantityTotal) || quantityTotal <= 0) {
          return;
        }

        const $button = $('.snize-custom-sold-out-button', this);

        if (!$button.length) {
          return;
        }

        $button
          .removeClass('snize-custom-sold-out-button')
          .addClass('snize-add-to-cart-button')
          .text(addToCartLabel);
      });
    }, 0);
  });
};

document.addEventListener('Searchanise.Loaded', restorePartialReelAddToCart);

if (window.Searchanise?.$) {
  restorePartialReelAddToCart();
}
